import { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../assets/Logo1.png";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinkClass = ({ isActive }) =>
    `relative font-medium transition ${
      isActive
        ? `${isScrolled ? 'text-trogoBlue' : 'text-white'} after:absolute after:-bottom-1 after:left-0 after:w-full after:h-[2px] after:bg-trogoOrange`
        : `${isScrolled ? 'text-trogoBlue' : 'text-white'} hover:text-trogoOrange`
    }`;

  return (
    <nav
      className={`fixed w-full top-0 z-50 transition-all duration-300 ${
        isScrolled ? "bg-white shadow-lg" : "bg-transparent"
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <img src={logo} alt="TROGO Logo" className="h-10 w-auto" />
          <div className="leading-tight">
            <h1 className="text-body font-bold text-trogoBlue">
              TOGOODS
            </h1>
            <p className="text-xs text-trogoOrange tracking-wide">
              Draft Private Limited
            </p>
          </div>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <NavLink to="/" className={navLinkClass}>Home</NavLink>
          <NavLink to="/about" className={navLinkClass}>About</NavLink>
          <NavLink to="/faq" className={navLinkClass}>FAQs</NavLink>
          <NavLink to="/contact" className={navLinkClass}>Contact</NavLink>
          <Link to="/contact">
          <button className="ml-4 bg-trogoOrange text-white px-6 py-2 rounded-full font-semibold shadow-md hover:shadow-lg hover:scale-105 transition">
            Download App
          </button></Link>
        </div>

        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className={`md:hidden focus:outline-none transition-colors ${
            isScrolled ? "text-trogoBlue" : "text-white"
          }`}
        >
          <svg
            className="w-7 h-7"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            {menuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white border-t px-6 py-6 space-y-5 shadow-inner">
          <NavLink onClick={() => setMenuOpen(false)} to="/" className="block text-trogoBlue font-medium">
            Home
          </NavLink>
          <NavLink onClick={() => setMenuOpen(false)} to="/about" className="block text-trogoBlue font-medium">
            About
          </NavLink>
          <NavLink onClick={() => setMenuOpen(false)} to="/faq" className="block text-trogoBlue font-medium">
            FAQ
          </NavLink>
          <NavLink onClick={() => setMenuOpen(false)} to="/contact" className="block text-trogoBlue font-medium">
            Contact
          </NavLink>

          <button className="w-full bg-trogoOrange text-white py-3 rounded-full font-semibold shadow hover:opacity-90">
           Download App
          </button>
        </div>
      )}
    </nav>
  );
}
